import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect, useState } from "react";
import type { TrackingDataModel } from "@/hooks/tracking/models/tracking-data-model.types";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
type InitLinkedInProps = {
  readonly trackingData: TrackingDataModel;
};
export function InitializeLinkedInInsightTag(t0) {
  const $ = _c(6);
  const {
    trackingData
  } = t0;
  const consent = useCookiebotConsent();
  const [isMarketingConsentGiven, setIsMarketingConsentGiven] = useState(false);
  let t1;
  let t2;
  if ($[0] !== consent || $[1] !== trackingData.linkedinInsightId) {
    t1 = () => {
      if (trackingData.linkedinInsightId === null) {
        return;
      }
      setIsMarketingConsentGiven(consent.marketing);
      const _linkedin_partner_id = trackingData.linkedinInsightId;
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids ?? [];
      if (!window._linkedin_data_partner_ids.includes(_linkedin_partner_id)) {
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      }
    };
    t2 = [trackingData.linkedinInsightId, consent];
    $[0] = consent;
    $[1] = trackingData.linkedinInsightId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== isMarketingConsentGiven) {
    t3 = isMarketingConsentGiven ? <Script id="LinkedInInsight" src="https://snap.licdn.com/li.lms-analytics/insight.min.js" strategy="afterInteractive" /> : null;
    $[4] = isMarketingConsentGiven;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}